export const scrollToTop = (element: HTMLElement | null) => {
  const scrollableParent = findScrollableParent(element);

  const targetElement =
    scrollableParent && scrollableParent !== document.documentElement && scrollableParent !== document.body
      ? scrollableParent
      : window;

  if (targetElement === window) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    (targetElement as Element).scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const findScrollableParent = (element: HTMLElement | null): Element | null => {
  if (!element) return null;

  let parent = element.parentElement;

  while (parent) {
    const style = window.getComputedStyle(parent);
    const overflowY = style.getPropertyValue('overflow-y');
    const overflow = style.getPropertyValue('overflow');

    if (overflowY === 'auto' || overflowY === 'scroll' || overflow === 'auto' || overflow === 'scroll') {
      if (parent.scrollHeight > parent.clientHeight) {
        return parent;
      }
    }

    parent = parent.parentElement;
  }

  return null;
};
